import gql from 'graphql-tag';

export default gql`
  mutation getEvent($eventId: String!) {
    getEvent(eventId: $eventId)
  }
`;
